import React from "react";
import {useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Table, Row, Col, UncontrolledTooltip} from "reactstrap";
import {getRunbook, postRunbook, updateRunbook} from "store/actions";
import TextInstructions from "./TextInstructions";
import Code from "./Code";

const Diagnostics = ({diagnostics, viewingFull, editable, alertId, id, sendDataToParent, type, runbook_created_at}) => {
  const dispatch = useDispatch();
  const [input, setInput] = useState(false);
  const order = useRef();
  const instruction = useRef();
  const code = useRef();
  const [dataToEdit, setDataToEdit] = useState(diagnostics);
  const [inputIndex, setInputIndex] = useState(-1);

  // useEffect(() => {
  //   dispatch(getRunbook(alertId));
  // }, [alertId, getRunbook, postRunbook, updateRunbook, setInput]);

  useEffect(() => {
    setDataToEdit(diagnostics);
  }, [diagnostics]);

  const onAddClick = (index) => {
    setInput(!input);
    setInputIndex(index);
  }

  const addInstruction = (index) => {
    let data = {
      runbook_id: id,
      instruction: instruction.current.value,
      code: code.current.value,
    };
    dataToEdit.splice(index, 0, data)
    sendDataToParent(dataToEdit)
    setInput(false);
  }

  function setCode(data) {
    dataToEdit.map((item, index) => {
      if (item.id === data.id) {
        item.code = data.code;
      }
    })
    data['runbook_id'] = id
    sendDataToParent(dataToEdit)
  }

  function setText(data) {
    dataToEdit.map((item, index) => {
      if (item.id === data.id) {
        item.instruction = data.instruction;
      }
    })
    data['runbook_id'] = id
    sendDataToParent(dataToEdit)
  }

  return (
    <React.Fragment>
      <div style={{maxWidth: "100%", paddingLeft: "1%"}}>
        {(editable ? dataToEdit :
          diagnostics)
          ?.slice()
          .sort((a, b) => a.order - b.order)
          .map((item, index) => (
            <div key={index}>
              <TextInstructions
                editable={editable}
                sendDataToParent={setText}
                id={item?.id}
                code={item?.code}
                textInstruction={item?.instruction}
                index={index}
                runbook_id={item?.runbook_id}
                type={type}
                runbook_created_at={runbook_created_at}
              />
              {item?.code ? (
                <div>
                  <Code
                    editable={editable}
                    sendDataToParent={setCode}
                    id={item?.id}
                    code={item?.code}
                    textInstruction={item?.instruction}
                    order={item?.order}
                    viewingFull={viewingFull}
                  />
                  {editable &&
                    <div className={`w-full d-flex justify-content-end`}>
                      <div>
                        <div
                          id="addTooltip"
                          onClick={() => onAddClick(index)}
                          className={`m-2 ${input ? 'bx bx-minus-circle mb-1' : 'bx bx-plus-circle mb-4'} text-success`}
                          style={{fontSize: "24px", cursor: "pointer"}}>
                        </div>
                        <UncontrolledTooltip placement="left" target="addTooltip">
                          {editable && input === true ? '' : "Add a new step"}
                        </UncontrolledTooltip>
                      </div>
                    </div>
                  }

                  {editable && input && inputIndex === index &&
                    <div>
                      <div className="d-flex w-100 ">
                        <Table>
                          <Row className="align-items-center my-2">
                            <Col lg={1}>Step {index + 2}: </Col>
                            <Col lg={11}>
                              <input
                                className="form-control"
                                style={{minHeight: "10px", color: "white"}}
                                placeholder="Text instruction"
                                ref={instruction}
                                type="text"/>
                            </Col>
                          </Row>
                          <Row className="align-items-center my-2">
                            <Col lg={1}>Code</Col>
                            <Col lg={11}>
                              <input
                                className="form-control"
                                placeholder="code"
                                style={{minHeight: "10px", color: "white"}}
                                ref={code} type="text"/>
                            </Col>
                          </Row>
                        </Table>
                      </div>
                      <div className="d-flex w-100 justify-content-end">
                        <button className="btn btn-primary mb-4" onClick={() => addInstruction(index + 1)}>Add step</button>
                      </div>
                    </div>
                  }
                </div>
              ) : (
                <br/>
              )}
            </div>
          ))
        }
      </div>
    </React.Fragment>
  )
}

export default Diagnostics;